module.exports = __webpack_public_path__ + "img/titleSet_pc.b2a041c0.svg";